import React from "react";
import "./Skills.css";
import useInView from "../hooks/useInView";

const skills = [
	{
		category: "Shopify",
		items: [
			"Liquid",
			"Shopify CLI",
			"Storefront API",
			"Admin API",
			"Metafields / Metaobjects",
			"App Development",
		],
	},
	{
		category: "Frontend",
		items: [
			"JavaScript",
			"React",
			"Next.js",
			"HTML / CSS",
			"Responsive Design",
			"GraphQL",
		],
	},
	{
		category: "Tools & Platforms",
		items: [
			"Git",
			"Google Cloud Run",
			"Firebase",
			"Performance Optimization",
			"Netlify CMS",
		],
	},
];

function Skills() {
	const [ref, visible] = useInView();

	return (
		<div className="skills" id="skills">
			<div className="shimmer skills_background">skills</div>
			<div
				ref={ref}
				className={`${visible ? "skills_reveal" : "skills_reveal_inactive"}`}
			>
				<div className="skills_container">
					{skills.map((group) => (
						<div key={group.category} className="skills_group">
							<h3 className="skills_group_title">{group.category}</h3>
							<ul className="skills_list">
								{group.items.map((item) => (
									<li key={item} className="skills_item">
										{item}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default Skills;
